module.exports = __webpack_public_path__ + "img/pm.1093d3c7.jpg";